import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { recordVisit } from "@/lib/api";

/**
 * Pings the backend once per route change so the directorate can count
 * unique visitors. The admin console is never reported, and each path is
 * only reported once per page session to avoid double counts from
 * re-renders or React strict mode.
 */
export const useVisitTracker = () => {
  const { pathname } = useLocation();
  const reported = useRef(new Set());

  useEffect(() => {
    if (!pathname || pathname.startsWith("/admin")) return;
    if (reported.current.has(pathname)) return;
    reported.current.add(pathname);

    const referrer =
      typeof document !== "undefined" && document.referrer
        ? document.referrer
        : "";

    recordVisit({ path: pathname, referrer }).catch(() => {
      // Analytics must never interfere with the reading experience.
      reported.current.delete(pathname);
    });
  }, [pathname]);
};
